import dayjs from 'dayjs';
import relativeTimePlugin from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTimePlugin);

export function relativeTime(date: Date): string {
  return dayjs(date).fromNow();
}

export function formatDateTime(date: Date): string {
  return dayjs(date).format('MMM D, YYYY h:mm A');
}
